import { rem } from 'polished';
import styled from 'styled-components';
import { IColors } from '../../interfaces/Conference';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    padding: ${rem(40)} 0 ${rem(15)} 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.secondaryGrey};
`;

export const Title = styled.span<{ colors: IColors }>`
    padding-bottom: ${rem(30)};
    display: inline-block;
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h4};
    position: relative;
    color: ${(props) => props.colors?.colorTitle};
`;

export const TitleSymbol = styled.span<{ colors: IColors }>`
    position: absolute;
    width: ${rem(40)};
    height: ${rem(5)};
    background: ${(props) => props.colors?.colorLine};
    left: 0;
    bottom: ${rem(15)};
`;

export const Description = styled.div<{ withBackground?: boolean; colors: IColors; withoutSidePadding?: boolean }>`
    margin: 0;
    padding: ${rem(20)} ${(prop) => (prop.withoutSidePadding ? rem(0) : rem(20))};
    line-height: ${rem(20)};
    ${(prop) => (!prop.withBackground ? '' : `background: ${prop.colors?.colorLightest}`)};
`;

export const DescAccomodations = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: start;

    @media (min-width: ${breakpoints.xs}px) {
        flex-direction: row;
    }
`;

export const DescAccomodation = styled.div<{ oneNight?: boolean }>`
    display: flex;
    flex-direction: column;
    width: 50%;
    ${(prop) => (prop.oneNight ? 'width: 100%' : 'width: 50%')};
    padding: ${rem(20)} ${rem(10)};
    align-items: start;

    @media (max-width: ${breakpoints.xs}px) {
        width: 100%;
    }
`;

export const Rooms = styled.div`
    margin-bottom: ${rem(30)};
    width: 80%;
    padding-left: 10%;
    @media (max-width: ${breakpoints.sm}px) {
        width: 100%;
        padding-left: 0;
    }
`;

export const Room = styled.div`
    //width: 100%;
    display: flex;
    //flex-direction: column;
    padding-bottom: ${rem(5)};
    align-items: center;
`;

export const RoomRow = styled.div<{ colors: IColors; }>`
    display: flex;
    margin-bottom: ${rem(5)};
    align-items: center;
    ${(prop) => (`background: ${prop.colors?.colorLight}`)};

`;

export const Col1 = styled.div<{ colors: IColors; isHead?: boolean }>`
    float: left;
    width: 33.3%;
    ${(prop) => (prop.isHead ? `background: ${prop.colors?.colorLink}` : `background: ${prop.colors?.colorLight}`)};
    ${(prop) => (prop.isHead ? `color: #fff ` : `color: #000`)};
    ${(prop) => (prop.isHead ? `padding: ${rem(10)} ${rem(10)}` : `padding: ${rem(6)} ${rem(10)}`)};
    align-items: left;
`;
export const Col2 = styled.div<{ colors: IColors; isHead?: boolean }>`
    float: left;
    width: 33.3%;
    //  display: flex;
    //  flex-direction: column;
    //width: 50%;
    ${(prop) => (prop.isHead ? `background: ${prop.colors?.colorLink}` : `background: ${prop.colors?.colorLight}`)};
    ${(prop) => (prop.isHead ? `color: #fff ` : `color: #000`)};
    ${(prop) => (prop.isHead ? `padding: ${rem(10)} ${rem(10)}` : `padding: ${rem(6)} ${rem(10)}`)};
    align-items: left;
`;
export const Col3 = styled.div<{ colors: IColors; isHead?: boolean }>`
    float: left;
    width: 33.3%;
    //   display: flex;
    //   flex-direction: column;
    //width: 50%;
    ${(prop) => (prop.isHead ? `background: ${prop.colors?.colorLink}` : `background: ${prop.colors?.colorLight}`)};
    ${(prop) => (prop.isHead ? `color: #fff ` : `color: #000`)};
    ${(prop) => (prop.isHead ? `padding: ${rem(10)} ${rem(10)}` : `padding: ${rem(6)} ${rem(10)}`)};

    align-items: left;
`;
